import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { ProvidersBillingService } from '../../../providers-billing/providers-billing-service.service';
import { IUserproviderInterface } from '../../../../core/interfaces/userprovider.interface';
import { ITripPaymentDenied } from '../../../../core/interfaces/trip-payment-denied.interface';
import { ComunicationDashboard } from '../../../dashboard-providers/comunication-dashboard';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';

@Component({
  selector: 'app-claims-denials',
  templateUrl: './claims-denials.component.html',
  styleUrls: ['./claims-denials.component.scss']
})
export class ClaimsDenialsComponent implements OnInit, OnDestroy {


  public gridDenials: GridOptions;
  public rowData: ITripPaymentDenied[];
  public userProviders: IUserproviderInterface[];
  public subscribe: Subscription[];
  public denied: number;
  public denied_appeal: number;
  private daysAllowed = 90;
  activeDeadline: boolean;
  currentDate: any;

  constructor(
    private _serviceDenials: ProvidersBillingService,
    private _comunicationDashboard: ComunicationDashboard
  ) {
    this.denied = 0;
    this.denied_appeal = 0;
    this.subscribe = [];
    this.createGrid();
  }

  ngOnInit() {
    this.comunication();
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(
      (sub: Subscription) => {
        sub.unsubscribe();
      }
    );
  }

  /**@name comunication
   * @description Trae el id
   */
  comunication() {
    const received$: Subscription = this._comunicationDashboard.receivedId.subscribe(
      (id: number) => {
        this.getClaimsDenilas(id);
      }
    );
    this.subscribe.push(received$);
  }

  /**@name getClaimsDenilas
   * @description Trae los trips denegados
   */
  getClaimsDenilas(providerid: number) {
    const denial$: Subscription = this._serviceDenials.getPaymentDenied(providerid).subscribe(
      (denials: ITripPaymentDenied[]) => {
        denials.forEach((row) => {
          if (row.dateofserviceformatted) {
            this.compareDates(row.dateofserviceformatted, this.currentDate);

            if (this.activeDeadline && row.definitivedenial === false) {
              row.definitivedenial = this.activeDeadline;
            }
          }
        });
        const DENIED_LIST = denials.filter((x: any) => x.definitivedenial );
        const APPEAL_LIST_DENIED = denials.filter((y: any) => !y.definitivedenial );
        this.denied = DENIED_LIST.length;
        this.denied_appeal = APPEAL_LIST_DENIED.length;
      },
      error => {
      }
    );
    this.subscribe.push(denial$);
  }


  /**@name createGrid
   * @description Crea la grilla
   */
  createGrid() {
    this.gridDenials = <GridOptions>{};
    this.gridDenials.columnDefs = this.createColums();
    const self = this;
    this.gridDenials.onGridReady = () => {
      self.gridDenials.api.sizeColumnsToFit();
    };
  }
  /**@name createColums
   * @description Retorna las columnas para la grilla
   */
  createColums() {
    return [
      {
        headerName: 'Trip #',
        field: 'tripid',
        colId: 'tripid',
        width: 60,
      },
      {
        headerName: 'Reason',
        field: 'paymentdeniedreason',
        colId: 'paymentdeniedreason',
        width: 100,
      },
      {
        headerName: 'Document',
        field: 'ridername',
        colId: 'ridername',
        width: 100,
      },
      {
        headerName: 'Date of Service',
        field: 'dateofserviceformatted',
        colId: 'dateofserviceformatted',
        width: 100,
      }
    ];
  }

  compareDates(one: any, tow: any) {
    const dateOne = moment(one);
    const dateTow = moment(tow);
    const difDate = dateTow.diff(dateOne, 'days');
    if (difDate > this.daysAllowed) {
      this.activeDeadline = true;
    } else { this.activeDeadline = false; }
  }

  getCurrentDate() {
    this.currentDate = moment().format('YYYY-MM-DD');
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/documents-verify/components/claims-denials/claims-denials.component.ts